import { FC, useCallback } from 'react'
import { Trans } from 'react-i18next'
import Image from 'next/image'
import { useTranslation } from '../../../../hooks/useTranslation'
import { listPartnerFixture } from '../fixture/partner.fixture'
import { useMixpanel } from 'src/@legacy/utilities/Mixpanel'
import IMAGE_NEST from '../assets/img/partner_nest.png'

const PartnerHH: FC<{ contactRef?; setIsLazyLoading?; getRef?; getRefMobile? }> = ({ setIsLazyLoading, getRef, getRefMobile }) => {
  const { translate } = useTranslation()
  const Mixpanel = useMixpanel()

  const handleScrollToSection = useCallback(() => {
    // console.log(contactRef.current)
    setIsLazyLoading(false)
    return Promise.all([
      getRef()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      }),

      getRefMobile()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      })
    ]).then(() => {
      return
    })
  }, [])
  return (
    <div className="partner">
      <div className="partner-blur-left" />
      <div className="partner-blur-right" />
      <div className="">
        <div className="partner-container">
          <div className="grid-column">
            <div className="partner-nest">
              <Image src={IMAGE_NEST} alt={`nest`} width={588} height={616} />
            </div>
            {listPartnerFixture.map((item, index) => (
              <div className="item" key={index}>
                <div className="image-wrapper">
                  <Image src={item.logo} alt={`logo-${index}`} />
                </div>
              </div>
            ))}
          </div>
          <div className="heading-wrapper">
            <h2 className="heading">
              <Trans i18nKey="page_employer_headhunt_service:partner_heading">
                <span className="high-light" />
              </Trans>
            </h2>
            <div className="sub-heading">{translate('page_employer_headhunt_service:sub_partner_heading')}</div>
            <div className="text-center">
              <a
                id="button_book_a_consultation_1"
                data-mixpanel-event={Mixpanel.EVENTS.CLICK_BOOK_A_CONSULTANT}
                className="btn-book-consultation"
                onClick={() => handleScrollToSection()}>
                {translate('page_employer_headhunt_service:lp_book_a_consultation')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnerHH
